import { useRef } from 'react';

export const useStableFunction = <A extends unknown[], R>(
  fn: (...args: A) => R
): ((...args: A) => R) => {
  const currentFnRef = useRef<(...args: A) => R>(fn);
  const stableFnRef = useRef<(...args: A) => R>(undefined);

  // eslint-disable-next-line react-hooks/refs
  currentFnRef.current = fn;

  // eslint-disable-next-line react-hooks/refs
  if (!stableFnRef.current) {
    stableFnRef.current = function (...args: A): R {
      return currentFnRef.current.call(this, ...args);
    };
  }

  // eslint-disable-next-line react-hooks/refs
  return stableFnRef.current;
};
